export default class DateEntry {
  constructor(element) {
    import(/* webpackChunkName: "DateEntry" */
    './DateEntryExternal.js').then(({ default: DateEntryExternal }) => {
      // eslint-disable-next-line
      let entry = new DateEntryExternal(element)
    })
  }
}
